// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2552":"5df855f6","3733":"5df855f6","4448":"dc651c9b"}[chunkId] + ".chunk.css";
};